import React from "react";

function ReadMoreButton(props) {
  const { onClick, isOpen = false } = props;
  const buttonText = isOpen ? "Read less" : "Read more";

  return (
    <div className="ReadMoreButtonWrapper">
      <a type="button" className="btn btn-text btn-text-blue" onClick={onClick}>
        {buttonText}
      </a>
    </div>
  );
}

export default ReadMoreButton;
